// extracted by mini-css-extract-plugin
module.exports = {"form":"BrandDealsSetup_form__6FFcY"};